import { messagesES } from './messages/es';

export default function messageFactory(
  message = { msg: 'Error desconocido' },
  language = 'es',
) {
  const messages = {
    es: messagesES,
  };

  return (messages[language] || messagesES)(message);
}

export function getMessageFromKey(type, ...config) {
  return messageFactory({ type, msg: 'Error desconocido' }, ...config);
}

export function getMessageFromAxiosResponse(axiosResponse, ...config) {
  return messageFactory(axiosResponse?.data?.detail, ...config);
}

export function getMessageFromAxiosError(axiosError, ...config) {
  return messageFactory(axiosError?.response?.data?.detail, ...config);
}
